import React from "react";
import {Route, Routes} from "react-router-dom";
import CreatePost from "../container/board/CreatePost";
import UpdatePost from "../container/board/UpdatePost";
import PostList from "../container/board/PostList";
import PostRead from "../container/board/PostRead";

const Post = () => {
  return (
    <Routes>
      <Route path="/:id" element={<PostList />} />
      <Route path="/Read/:id" element={<PostRead />} />
      <Route path="Create/:id/:name" element={<CreatePost />} />
      <Route path="Edit/:id/:name" element={<UpdatePost />} />
    </Routes>
  );
};

export default Post;
